import { stableSort, getSorting, formatDateShortMon } from '../../../Functions';

export function StowagePlanHeaderCompose(page, rowL, sp, dataUrl, data) {
    var doc = sp;
    var _y = rowL;
    var _space = page.spacingunit;

    var imageX = 85;
    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 50, 23);

    doc.setFont("times", "bold")
    doc.text(175, _y, 'LEGEND:');
    doc.setFont("times", "normal");

    _y += _space;
    doc.setFillColor('#defff0');
    doc.rect(170, _y - (_space - 1), 25, 10, 'FD');
    doc.setFont("times", "italic");
    doc.text(175, _y + 2, 'Occupied');

    _y += _space * 2;
    doc.setFillColor('#fcffcc');
    doc.rect(170, _y - (_space - 1), 25, 10, 'FD');
    doc.text(175, _y + 2, 'Empty');
    doc.setFont("times", "normal");
    doc.setFillColor('#FFFFFF');

    doc.setFont("times", "bold");
    doc.text('STOWAGE PLAN', 110, _y, null, null, 'center');
    doc.setFont("times", "normal");

    _y += _space;
    doc.text(data.actualVesselName ? data.actualVesselName : data.vesssel ? data.vesssel : '', 110, _y, null, null, 'center');

    _y += _space;
    doc.text(20, _y, 'ORIGIN: ' + data.origin);
    doc.text(125, _y, 'DATE: ' + formatDateShortMon(data.date));

    _y += _space;
    doc.text(20, _y, 'DESTINATION: ' + data.destination);
    doc.text(125, _y, 'VOYAGE: ' + data.voyageNum + ' / ' + data.voyageRef);

    _y += (_space / 2);
    doc.line(20, _y + 1, 195, _y + 1);

    _y += _space;

    return _y;
}

export function StowagePlanGridCompose(page, rowL, sp, template, detail) {
    var doc = sp;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += (_space / 2);
    doc.setFont("times", "bold");
    doc.text('STERN', 110, _y, null, null, 'center');
    doc.setFont("times", "normal");
    _y += _space;
    doc.setFontSize(9);
    template.forEach(element => {
        var x = element.column === 0 ? element.column + 15 : (element.column * 4) + 15;
        var y = element.row === 0 ? (element.row + _y) : ((element.row * 4) + _y);
        var w = element.width * 4;
        var h = element.height * 4;
        var position = doc.splitTextToSize(element.position ? element.position : '', w);

        if (detail && detail.length > 0) {
            var detailPosition, EachPosition;
            detailPosition = detail.map(ele => ele.location.find(l => l === element.position));
            // eslint-disable-next-line
            detailPosition.map(d => {
                if (d === element.position) {
                    EachPosition = d;
                }
            })
            doc.setFillColor(EachPosition ? '#defff0' : '#fcffcc');
        }
        else {
            doc.setFillColor('#FFFFFF');
        }

        if (element.position === 'PILOT HOUSE') {
            doc.setFillColor('#CACFD2');
        }

        doc.rect(x, y, w, h, 'FD');

        doc.setFillColor('#FFFFFF');

        doc.text(x + 0.5, y + 2.8, position);

    });

    var highest = template.reduce((max, current) => current.row > max.row ? current : max, { row: 0 })
    _y += (_space * highest.row);

    doc.setFontSize(10);
    doc.setFont("times", "bold");
    doc.text('BOW', 110, _y, null, null, 'center');
    doc.setFont("times", "normal");

    _y += _space;

    return _y;
}

export function StowagePlanDataCompose(page, rowL, sp, data) {
    var doc = sp;
    var _y = rowL;
    var _space = page.spacingunit;

    if (_y > 250) {
        doc.addPage(page.layout, page.papersize.unit, page.papersize.format);
        _y = 5;
    }

    _y += _space * 2;

    var _x = 20;
    var _xSpace = 50;
    var re_x = _x;

    doc.setFont("times", "bold");
    _x += _space;
    doc.text(_x, _y, 'CARGO');
    _x += (_space * 8);
    doc.text(_x, _y, 'LOCATION');
    doc.setFont("times", "normal");
    doc.line(re_x, _y + 1, _x + 25, _y + 1);

    _x += _xSpace;
    re_x = _x;

    doc.setFont("times", "bold");
    _x += _space;
    doc.text(_x, _y, 'CARGO');
    _x += (_space * 8);
    doc.text(_x, _y, 'LOCATION');
    doc.setFont("times", "normal");
    doc.line(re_x, _y + 1, _x + 25, _y + 1);

    _y += _space;
    _x = 20;
    re_x = _x;
    var columnNum = 1;
    var FinalData = [];

    data.forEach(element => {
        element.location.forEach(ele => {
            FinalData.push({ containerVanNum: element.containerVanNum, location: ele })
        });
    });

    if (FinalData.length > 0) {
        // eslint-disable-next-line
        stableSort(FinalData, getSorting('asc', 'location')).map(d => {
            _x += _space;

            doc.text(_x, _y, d.containerVanNum ? d.containerVanNum : '');
            _x += (_space * 8);
            doc.text(_x, _y, d.location ? d.location : '');
            doc.line(re_x, _y + 1, _x + 25, _y + 1);

            if (columnNum === 2) { columnNum = 1; _x = 20; re_x = _x; _y += _space; }
            else { _x += _xSpace; re_x = _x; columnNum = 2; }

            if (_y > 270) {
                doc.addPage(page.layout, page.papersize.unit, page.papersize.format);
                _y = 5;
                _y += _space * 2;

                _x = 20;
                re_x = _x;

                doc.setFont("times", "bold");
                _x += _space;
                doc.text(_x, _y, 'CARGO');
                _x += (_space * 8);
                doc.text(_x, _y, 'LOCATION');
                doc.setFont("times", "normal");
                doc.line(re_x, _y + 1, _x + 25, _y + 1);

                _x += _xSpace;
                re_x = _x;

                doc.setFont("times", "bold");
                _x += _space;
                doc.text(_x, _y, 'CARGO');
                _x += (_space * 8);
                doc.text(_x, _y, 'LOCATION');
                doc.setFont("times", "normal");
                doc.line(re_x, _y + 1, _x + 25, _y + 1);

                _y += _space;
                _x = 20;
                re_x = _x;
            }
        })
    }
}